import * as PIXI from "pixi.js";
import Main from "../Main";
import BaseLayer from "./BaseLayer";

import HTPFirstPart from "../entities/howtoplay/HTPFirstPart";
import HTPSecondPart from "../entities/howtoplay/HTPSecondPart";
import HTPThirdPart from "../entities/howtoplay/HTPThirdPart";
import HTPFourthPart from "../entities/howtoplay/HTPFourthPart";

import { EventBus, EnumEventBus } from "../managers/EventBus";
import { testGridData } from "../types/Config";

export default class HowToPlayLayer extends BaseLayer {
  static instance: HowToPlayLayer;
  private Main = Main.getInstance();
  private EventBus = EventBus;
  private HTPFirstPart: HTPFirstPart;
  private HTPSecondPart: HTPSecondPart;
  private HTPThirdPart: HTPThirdPart;
  private HTPFourthPart: HTPFourthPart;
  private handleFuncType: "2" | "3" | "4" | "5" | "" = "";

  constructor() {
    super();
    if (!HowToPlayLayer.instance) {
      HowToPlayLayer.instance = this
    }

    this.interactive = true;

    this.addBg();
    this.addParts();
    this.hideParts();
    //

    this.on("mousedown", () => this.handlePress());
    this.on("touchstart", () => this.handlePress());

    this.EventBus.emit(EnumEventBus.updateWFireworkTexture, testGridData[0]);
    this.EventBus.on(EnumEventBus.setHFType, s => this.handleFuncType = s);
  }

  handlePress() {
    if (this.handleFuncType == "2") {
      this.handleFuncType = ""
      this.HTPFirstPart.runReverseAnimations(() => {
        this.HTPFirstPart.visible = false;
        this.runPart(this.HTPSecondPart);
      });
    } else if (this.handleFuncType == "3") {
      this.handleFuncType = ""
      this.HTPSecondPart.runReverseAnimations(() => {
        this.runPart(this.HTPThirdPart);
      })
    }
    else if (this.handleFuncType == "4") {
      this.handleFuncType = ""
      this.HTPThirdPart.runReverseAnimations(() => {
        this.HTPThirdPart.visible = false;
        this.runPart(this.HTPFourthPart);
      })
    }
    else if (this.handleFuncType == "5") {
      this.handleFuncType = ""
      this.HTPFourthPart.runReverseAnimations(() => {
        this.HTPFourthPart.visible = false;
        this.HTPSecondPart.visible = false;
        this.EventBus.emit(EnumEventBus.setHowToPlayMode, false)
      })
    }
  }

  addBg() {
    const dim = this.Main.getDim();
    const bg = new PIXI.Graphics()
      .rect(0, 0, dim.width, dim.height)
      .fill(0x000000)
    bg.alpha = 0;
    this.addChild(bg);
  }
  start() {
    this.runPart(this.HTPFirstPart);
  }
  addParts() {
    this.HTPFirstPart = new HTPFirstPart();
    this.HTPSecondPart = new HTPSecondPart();
    this.HTPThirdPart = new HTPThirdPart();
    this.HTPFourthPart = new HTPFourthPart();
  }

  hideParts() {
    this.HTPFirstPart.visible = false;
    this.HTPSecondPart.visible = false;
    this.HTPThirdPart.visible = false;
    this.HTPFourthPart.visible = false;
  }

  runPart(part: HTPFirstPart | HTPSecondPart | HTPThirdPart | HTPFourthPart) {
    part.visible = true;
    part.runAnimations();
  }
  static getInstance() {
    return HowToPlayLayer.instance
  }
}